var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.dialogs),function(dialog){return _c('div',{key:dialog.id},[_c('div',{staticClass:"box"},[_c('myDialog',{attrs:{"dialog-name":dialog.name,"dialog-id":dialog.id,"dialog-description":dialog.description,"dialog-questions":dialog.questions}})],1)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b809dc0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./_source/javascripts/modules/profile/dialogs.vue
// module id = 462
// module chunks = 0